export type Breakpoint = "xl" | "lg" | "md" | "sm" | "xs" | "xxs" | "xxxs";

export const breakpoints: {
    [key in Breakpoint]: number;
} = {
    xxxs: 200,
    xxs: 300,
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1600,
};

export function getBreakpoint(width: number): Breakpoint {
    const { xxxs, xxs, xs, sm, md, lg } = breakpoints;
    if (width < xxxs) {
        return "xxxs";
    }
    if (width < xxs) {
        return "xxs";
    } else if (width < xs) {
        return "xs";
    } else if (width < sm) {
        return "sm";
    } else if (width < md) {
        return "md";
    } else if (width < lg) {
        return "lg";
    } else {
        return "xl";
    }
}
